
export default class RegularHelper
{
	static castStringPatternToRegularPattern(str)
	{
		var reg; 
		
		if(str.indexOf("*") != 0)
		{
			reg = "^" + str;
		}
		else
		{
			reg = str;
		}
		
		if(str.lastIndexOf("*") != str.length-1 && 
			str.lastIndexOf("?") != str.length-1)
		{
			reg += "$"; 
		}
		
		reg = reg.replace(/\*/g,".*");
		//reg = reg.replace("*",".*");
		reg = reg.replace(/\?/g,".{0,1}");
		
		return reg;
	}
	
	static setThounsandSeperator(chars,sptor = ",")
	{
		var result = "";
		var reverseChar = chars.reverse();
		var i = 1;
		for(var k in reverseChar)
		{
			var c = reverseChar[k];
			if(c == "-")
			{
				result = (c+result);
				continue;
			}
			
			result = (c + result);
			
			if(i%3==0 && i!=reverseChar.length)
				result = (sptor + result);
			i++;
		}
		
		if(result.charAt(0)=="-" && result.charAt(1) == sptor)
			result = result.substr(0,1) + result.substr(2);
		
		return result;
	}
		
}


// WEBPACK FOOTER //
// ./src/utils/RegularUtil.js